export const beamRenderProfiles = {
  default: {
    renderMode: 'legacy',
    enableRotation: false,
    enableDynamicGap: false,
    enableBeamColors: true,
    orderWidthSpacing: 25,
    beamBuild: ['bottomTension', 'bottomN1D', 'coreN2M', 'topN1D', 'topTension'],
    beamBuildText: ['BT', 'A', 'B', 'A', 'TT'],
    beamColors: ['#071ffcff', '#CD853F', '#A0522D', '#CD853F', '#8B4513'],
    textColors: ['#ff8888', '#8888ff', '#ffffff', '#8888ff', '#ff8888'],
    beamSingleScale: 2,
    beamSingleGap: null,
    beamSingleGlued: false,
    beamSingleEnableRotation: null,
    beamSingleRotation: null,
    useNormalizedLayerSpacing: true,
    textXOffset: 0,
    textYOffset: 0,
    textZOffset: 0,
    textXStep: 0,
    textYStep: 0,
    textZStep: 0,
    renderQualityText: true,
    useLamellaInstancing: false,
    lamellaInstancingMinCount: 20,
    stackDirection: 'vertical',
    bundleSize: null
  },
  lehmann: {
    renderMode: 'enhanced',
    beamBuild: ['bottomTension', 'bottomN1D', 'coreN2M', 'topN1D', 'topTension'],
    beamBuildText: ['DL-NSI', 'ML-NSI', 'DL', 'ML', 'NSI', 'C24', 'default'],
    beamColors: ['#ffd36b', '#5acbff', '#A0522D', '#CD853F', '#8B4513'],
    textColors: ['#ffd36b', '#5acbff', '#ffdf77', '#77baff', '#cccccc', '#5cf8a0', '#e0e0e0'],
    orderVerticalGap: 0.0023,
    orderWidthSpacing: 6,
    enableRotation: true,
    rotationAngle: -Math.PI / 2,
    enableDynamicGap: true,
    enableBeamColors: true,
    widthScaleDiv: 10,
    thicknessScaleMultiplier: 1,
    lengthScaleMultiplier: 1,
    useNormalizedLayerSpacing: false,
    // Posebej samo za layered pogled, če ni vrednosti se pobirajo z zgornji
    beamSingleScale: 1,
    beamSingleGapRaw: 1.0177,
    beamSingleGlued: true, // TODO: formula za vse debeline
    beamSingleEnableRotation: false,
    beamSingleRotation: -Math.PI / 2,
    beamSingleWidthScaleDiv: 25.4,
    textXOffset: 0,
    textYOffset: 0,
    textZOffset: 0,
    textXStep: 0,
    textYStep: 0.3,
    textZStep: 0.1,
    renderQualityText: true,
    useLamellaInstancing: true,
    lamellaInstancingMinCount: 5,
    stackDirection: 'vertical',
    bundleSize: null
  },
  fournier: {
    renderMode: 'enhanced',
    useLamellaTexture: true,
    beamBuild: ['bottomTension', 'bottomN1D', 'coreN2M', 'topN1D', 'topTension'],
    // beamBuildText: ['DL-NSI', 'ML-NSI', 'DL', 'ML', 'NSI', 'C24', 'default'],

    beamColors: ['#ffd36b', '#5acbff', '#A0522D', '#CD853F', '#8B4513'],
    textColors: ['#ffd36b', '#5acbff', '#ffdf77', '#77baff', '#cccccc', '#5cf8a0', '#e0e0e0'],
    orderVerticalGap: 0.0023,
    orderWidthSpacing: 6,
    enableRotation: true,
    rotationAngle: -Math.PI / 2,
    enableDynamicGap: true,
    enableBeamColors: true,
    widthScaleDiv: 10,
    thicknessScaleMultiplier: 2,
    lengthScaleMultiplier: 1,
    useNormalizedLayerSpacing: false,
    beamSingleScale: 2,
    beamSingleGapRaw: 1.0177,
    beamSingleGlued: true,
    beamSingleEnableRotation: true,
    beamSingleRotation: -Math.PI / 2,
    beamSingleWidthScaleDiv: 25.4,
    textXOffset: 0,
    textYOffset: 0,
    textZOffset: 0,
    textXStep: 0,
    textYStep: 0.3,
    textZStep: 0.1,
    renderQualityText: false,
    useLamellaInstancing: false,
    lamellaInstancingMinCount: 20,
    stackDirection: 'vertical',
    bundleSize: null
  },
  test: {
    renderMode: 'enhanced',
    beamBuild: ['bottomTension', 'bottomN1D', 'coreN2M', 'topN1D', 'topTension'],
    beamBuildText: ['DL-NSI', 'ML-NSI', 'DL', 'ML', 'NSI', 'C24', 'default'],
    beamColors: ['#70fa00ff', '#5acbff', '#A0522D', '#CD853F', '#8B4513'],
    textColors: ['#ff018dff', '#5acbff', '#ffdf77', '#77baff', '#cccccc', '#5cf8a0', '#e0e0e0'],
    orderVerticalGap: 0.2, // gap med lamellama v layeru
    orderWidthSpacing: 50, // gap med layerema v groupview
    enableRotation: false, // za rotacijo lamell v primeru da so glued da prikaz pokaze kak bi to zgledalo
    rotationAngle: -Math.PI / 6,
    enableBeamColors: true,
    beamSingleScale: 2,
    beamSingleGap: null,
    beamSingleGlued: false,
    beamSingleEnableRotation: null,
    beamSingleRotation: null,
    widthScaleDiv: 25.4,
    beamSingleWidthScaleDiv: 25.4,
    thicknessScaleMultiplier: 0.5,
    lengthScaleMultiplier: 1,
    useNormalizedLayerSpacing: false, // true bo delal tak kot je prej nastavljena fixna višina in notri bo jih stackalo
    // false pa bo enega nad drugim renderalo s tem da lah uporabis orderVerticalGap kakšen gap bo med lamelama
    textXOffset: 0,
    textYOffset: 0,
    textZOffset: 0,
    textXStep: 0,
    textYStep: 0,
    textZStep: 0,
    renderQualityText: true,
    useLamellaInstancing: false,
    lamellaInstancingMinCount: 20,
    stackDirection: 'vertical',
    bundleSize: null
  },
  Zpress: {
    renderMode: 'enhanced',
    useLamellaTexture: false,
    beamBuild: ['finished', 'pending'],
    beamBuildText: [],
    beamColors: ['#ff0000', '#00aaff'],
    textColors: [],
    orderVerticalGap: 0.0023,
    orderWidthSpacing: 6,
    enableRotation: false,
    rotationAngle: -Math.PI / 2,
    enableDynamicGap: false,
    enableBeamColors: true,
    widthScaleDiv: 5,
    thicknessScaleMultiplier: 1,
    lengthScaleMultiplier: 1,
    useNormalizedLayerSpacing: false,
    beamSingleScale: 1,
    beamSingleGap: null,
    beamSingleGapRaw: 1.0177,
    beamSingleGlued: true,
    beamSingleEnableRotation: false,
    beamSingleRotation: -Math.PI / 2,
    fixedLamellaWidth: null,
    fixedLamellaThickness: null,
    fixedLamellaLength: 27000,
    beamSingleWidthScaleDiv: 25.4,
    textXOffset: 0,
    textYOffset: 0,
    textZOffset: 0,
    textXStep: 0,
    textYStep: 0.3,
    textZStep: 0.1,
    stackDirection: 'horizontal',
    bundleSize: 2000,
    renderQualityText: false,
    useLamellaInstancing: true,
    lamellaInstancingMinCount: 5
  },
  holder: {
    renderMode: 'enhanced',
    useLamellaTexture: false,
    beamBuild: ['bottomTension', 'bottomN1D', 'coreN2M', 'topN1D', 'topTension'],
    beamBuildText: ['DL-NSI', 'ML-NSI', 'DL', 'ML', 'NSI', 'C24', 'default'],
    beamColors: ['#ffd36b', '#5acbff', '#A0522D', '#CD853F', '#8B4513'],
    textColors: ['#ffd36b', '#5acbff', '#ffdf77', '#77baff', '#cccccc', '#5cf8a0', '#e0e0e0'],
    orderVerticalGap: 0.0023,
    orderWidthSpacing: 6,
    enableRotation: true,
    rotationAngle: -2.08,
    enableDynamicGap: true,
    enableBeamColors: true,
    useLamellaInstancing: true,
    lamellaInstancingMinCount: 5,
    widthScaleDiv: 10,
    thicknessScaleMultiplier: 1,
    lengthScaleMultiplier: 1,
    useNormalizedLayerSpacing: false,
    beamSingleScale: 1,
    beamSingleGap: null,
    beamSingleGapRaw: 1.0177,
    beamSingleGlued: true,
    beamSingleEnableRotation: true,
    beamSingleRotation: -1.5807963267949,
    fixedLamellaWidth: 500,
    fixedLamellaThickness: null,
    fixedLamellaLength: 24500,
    beamSingleWidthScaleDiv: 25.4,
    textXOffset: 0,
    textYOffset: 0,
    textZOffset: 0,
    textXStep: 0,
    textYStep: 0.3,
    textZStep: 0.1,
    stackDirection: 'vertical',
    bundleSize: null,
    renderQualityText: false
  }
};

let _runtimeOverride = null;

export function setRuntimeBeamProfile(profileName, config) {
  _runtimeOverride = profileName && config ? { name: profileName, config } : null;
}

export function getRuntimeBeamProfile() {
  return _runtimeOverride;
}

export function resolveBeamOptions(userOptions = {}, profile = 'default') {
  const profileName = userOptions?.beamRenderProfile || profile;
  const overrideBase = _runtimeOverride && _runtimeOverride.name === profileName ? _runtimeOverride.config : null;
  const base = overrideBase || beamRenderProfiles[profileName] || beamRenderProfiles.default;
  const safeUserOptions = userOptions || {};

  const pickDefined = (baseVal, overrideVal) => {
    if (overrideVal === undefined || overrideVal === null) return baseVal;
    if (Array.isArray(overrideVal)) {
      return overrideVal.length ? overrideVal : baseVal;
    }
    return overrideVal;
  };

  return {
    ...base,
    ...safeUserOptions,
    beamBuild: pickDefined(base.beamBuild, safeUserOptions.beamBuild),
    beamBuildText: pickDefined(base.beamBuildText, safeUserOptions.beamBuildText),
    beamColors: pickDefined(base.beamColors, safeUserOptions.beamColors),
    textColors: pickDefined(base.textColors, safeUserOptions.textColors)
  };
}
